/**
 * 아이콘 이름 → SVG 매핑
 * Interview Coach 강점/보완 필요/STAR 가이드 섹션에서 사용
 * Gmail 이메일 처리 완료 카테고리에서 사용
 */
const iconMap: Record<string, { svg: React.ReactNode; color: string }> = {
  'star-fill': {
    svg: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Star</title>
        <mask
          id="mask-star-fill"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.6332 3.07823C11.1674 1.91012 12.8271 1.91013 13.3613 3.07823L15.6212 8.01904L21.023 8.63904C22.3002 8.78563 22.8133 10.3659 21.8658 11.2348L17.8616 14.9069L18.9403 20.2292C19.1956 21.4885 17.8527 22.4649 16.7335 21.8338L11.9972 19.1631L7.26103 21.8338C6.14179 22.4649 4.79891 21.4885 5.05415 20.2292L6.13289 14.9069L2.12865 11.2348C1.18117 10.3659 1.69425 8.78563 2.97144 8.63904L8.37329 8.01904L10.6332 3.07823Z"
            fill="black"
          />
        </mask>
        <g mask="url(#mask-star-fill)">
          <rect width="24.0001" height="24" fill="currentColor" />
        </g>
      </svg>
    ),
    color: '#0084FF',
  },
  'circle-check-filled': {
    svg: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Check</title>
        <mask
          id="mask-circle-check"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.99742 1.66699C5.39504 1.66699 1.66406 5.39795 1.66406 10.0003C1.66406 14.6027 5.39504 18.3337 9.99742 18.3337C14.5998 18.3337 18.3308 14.6027 18.3308 10.0003C18.3308 5.39795 14.5998 1.66699 9.99742 1.66699ZM9.33668 13.0896L14.3367 8.08958L13.1582 6.91107L8.74742 11.3218L6.83667 9.41107L5.65815 10.5896L8.15816 13.0896L8.74742 13.6788L9.33668 13.0896Z"
            fill="black"
          />
        </mask>
        <g mask="url(#mask-circle-check)">
          <rect width="20.0001" height="20" fill="currentColor" />
        </g>
      </svg>
    ),
    color: '#30C353',
  },
  'circle-alert-filled': {
    svg: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Alert</title>
        <mask
          id="mask-circle-alert"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.66406 10.0003C1.66406 5.39795 5.39504 1.66699 9.99742 1.66699C14.5998 1.66699 18.3308 5.39795 18.3308 10.0003C18.3308 14.6027 14.5998 18.3337 9.99742 18.3337C5.39504 18.3337 1.66406 14.6027 1.66406 10.0003ZM10.8308 13.7503C10.8308 14.2106 10.4577 14.5837 9.99742 14.5837C9.53719 14.5837 9.16409 14.2106 9.16409 13.7503C9.16409 13.2901 9.53719 12.917 9.99742 12.917C10.4577 12.917 10.8308 13.2901 10.8308 13.7503ZM10.8308 11.667V5.41699H9.16409V11.667H10.8308Z"
            fill="black"
          />
        </mask>
        <g mask="url(#mask-circle-alert)">
          <rect width="20.0001" height="20" fill="currentColor" />
        </g>
      </svg>
    ),
    color: '#FF0000',
  },
  // Gmail 이메일 처리 완료 카테고리용 아이콘 (Figma 디자인 기준)
  // 긴급 확인: circle-alert (outline)
  'gmail-critical': {
    svg: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>긴급 확인</title>
        <mask
          id="mask-gmail-critical"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.0013 3.33366C6.31942 3.33366 3.33464 6.31843 3.33464 10.0003C3.33464 13.6822 6.31942 16.667 10.0013 16.667C13.6832 16.667 16.668 13.6822 16.668 10.0003C16.668 6.31843 13.6832 3.33366 10.0013 3.33366ZM1.66797 10.0003C1.66797 5.39795 5.39894 1.66699 10.0013 1.66699C14.6037 1.66699 18.3347 5.39795 18.3347 10.0003C18.3347 14.6027 14.6037 18.3337 10.0013 18.3337C5.39894 18.3337 1.66797 14.6027 1.66797 10.0003ZM10.8347 13.7503C10.8347 14.2106 10.4616 14.5837 10.0013 14.5837C9.54109 14.5837 9.16799 14.2106 9.16799 13.7503C9.16799 13.2901 9.54109 12.917 10.0013 12.917C10.4616 12.917 10.8347 13.2901 10.8347 13.7503ZM10.8347 11.667V5.41699H9.16799V11.667H10.8347Z"
            fill="black"
          />
        </mask>
        <g mask="url(#mask-gmail-critical)">
          <rect width="20.0001" height="20" fill="currentColor" />
        </g>
      </svg>
    ),
    color: '#000000',
  },
  // 참조 정보: circle-check (outline)
  'gmail-reference': {
    svg: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>참조 정보</title>
        <mask
          id="mask-gmail-reference"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.33464 10.0003C3.33464 6.31843 6.31942 3.33366 10.0013 3.33366C13.6832 3.33366 16.668 6.31843 16.668 10.0003C16.668 13.6822 13.6832 16.667 10.0013 16.667C6.31942 16.667 3.33464 13.6822 3.33464 10.0003ZM10.0013 1.66699C5.39894 1.66699 1.66797 5.39795 1.66797 10.0003C1.66797 14.6027 5.39894 18.3337 10.0013 18.3337C14.6037 18.3337 18.3347 14.6027 18.3347 10.0003C18.3347 5.39795 14.6037 1.66699 10.0013 1.66699ZM9.34058 13.0896L14.3406 8.08958L13.1621 6.91107L8.75132 11.3218L6.84057 9.41107L5.66206 10.5896L8.16207 13.0896L8.75132 13.6788L9.34058 13.0896Z"
            fill="black"
          />
        </mask>
        <g mask="url(#mask-gmail-reference)">
          <rect width="20.0001" height="20" fill="currentColor" />
        </g>
      </svg>
    ),
    color: '#000000',
  },
  // 삭제 대상: trash
  'gmail-trash': {
    svg: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>삭제 대상</title>
        <mask
          id="mask-gmail-trash"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.08465 3.33366H12.918V1.66699H7.08465V3.33366ZM18.3347 6.66699H16.668V15.8337C16.668 17.2144 15.5487 18.3337 14.168 18.3337H5.83465C4.45393 18.3337 3.33464 17.2144 3.33464 15.8337V6.66699H1.66797V5.00033H18.3347V6.66699ZM5.00131 6.66699H15.0013V15.8337C15.0013 16.2939 14.6282 16.667 14.168 16.667H5.83465C5.37441 16.667 5.00131 16.2939 5.00131 15.8337V6.66699ZM7.08465 14.167V9.16699H8.75132V14.167H7.08465ZM11.2513 9.16699V14.167H12.918V9.16699H11.2513Z"
            fill="black"
          />
        </mask>
        <g mask="url(#mask-gmail-trash)">
          <rect width="20.0001" height="20" fill="currentColor" />
        </g>
      </svg>
    ),
    color: '#000000',
  },
  // 보관 처리: archive
  'gmail-archive': {
    svg: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>보관 처리</title>
        <mask
          id="mask-gmail-archive"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <path d="M7.50132 12.0833H12.5013V10.4167H7.50132V12.0833Z" fill="#181819" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.91797 7.5H3.33464V16.6667C3.33464 17.1269 3.70774 17.5 4.16798 17.5H15.8347C16.2949 17.5 16.668 17.1269 16.668 16.6667V7.5H17.0847C17.775 7.5 18.3347 6.94036 18.3347 6.25V3.75C18.3347 3.05964 17.775 2.5 17.0847 2.5H2.91797C2.22761 2.5 1.66797 3.05964 1.66797 3.75V6.25C1.66797 6.94036 2.22761 7.5 2.91797 7.5ZM3.33464 4.16667V5.83333H16.668V4.16667H3.33464ZM5.00131 7.5H15.0013V15.8333H5.00131V7.5Z"
            fill="#181819"
          />
        </mask>
        <g mask="url(#mask-gmail-archive)">
          <rect width="20.0001" height="20" fill="currentColor" />
        </g>
      </svg>
    ),
    color: '#000000',
  },
};

interface IconBlockProps {
  name: string;
  size?: number;
}

/**
 * IconBlock - 아이콘 블록
 *
 * Figma 디자인 기준:
 * - 강점: circle-check-filled (#30C353)
 * - 보완 필요: circle-alert-filled (#FF0000)
 */
export function IconBlock({ name, size = 20 }: IconBlockProps) {
  const iconConfig = iconMap[name];

  if (!iconConfig) {
    return null;
  }

  return (
    <div className="shrink-0" style={{ width: size, height: size, color: iconConfig.color }}>
      {iconConfig.svg}
    </div>
  );
}
